var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10647 8.95844L0.996424 2.14502C0.826088 1.91791 0.826074 1.46368 1.05319 1.16086C1.10997 1.00945 1.28029 0.933746 1.39384 0.933746C1.5074 0.933746 1.62098 1.00945 1.73454 1.16086L6.50393 7.52004L11.2733 1.16086C11.3301 1.00945 11.5004 0.933746 11.614 0.933746C11.7275 0.933746 11.8411 1.00945 11.9547 1.16086C12.1818 1.46368 12.1818 1.8422 11.9547 2.14502L6.8446 8.95844C6.78782 9.03414 6.73103 9.10985 6.67425 9.10985C6.5607 9.18555 6.39037 9.18555 6.27681 9.10985C6.22004 9.03414 6.16325 9.03414 6.10647 8.95844Z",
    fill: "#767E95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectDownArrow);
export default __webpack_public_path__ + "static/media/select-down-arrow.f5d88992399bd05cc10f5d63b8efc4ff.svg";
export { ForwardRef as ReactComponent };